import http from '../services/http';

export default {
  namespaced: true,

  state: {
    languages: null,
    countries: null,
  },

  mutations: {
    CLEAR_ALL(state) {
      state.buyChannels = [];
      state.buyChannel = null;
    },
    SET_LANGUAGES(state, data) {
      state.languages = data;
    },
    SET_COUNTRIES(state, data) {
      state.countries = data;
    },
  },
  actions: {
    find({ commit }) {
      return http('/languages')
        .then((response) => response.body)
        .then((item) => {
          commit('SET_LANGUAGES', item.languages);
          commit('SET_COUNTRIES', item.countries);
        });
    },
  },
};
